<script src="../../../../utils/data-check.js"></script>
<template>
  <div style="height: 480px; overflow-x:auto">
    <el-row class="form" style=" margin-top: 20px;">
      <el-col :xl="4" :lg="4" :md="4" :sm="4" :xs="7" style="text-align: right;margin-right: 2%">邮件服务器：</el-col>
      <el-col :xl="18" :lg="18" :md="18" :sm="18" :xs="16">
        <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="23">
          <el-switch
            style="display: block;"
            v-model="emailNotificationNoticeData.mailServerVal"
            active-color="#13ce66"
            inactive-color="#ff4949"
            inactive-text="禁用"
            active-text="启用">
          </el-switch>
        </el-col>
        <el-form v-if="emailNotificationNoticeData.mailServerVal" label-width="120px">
          <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="23" style="margin-top: 20px;">
            <el-form-item label="服务器地址:">
              <el-input placeholder="请输入服务器地址" size="mini" v-model="mailSMTPData.val1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="23">
            <el-form-item label="SSL:">
              <el-switch
                style="display: block; margin-top: 8px;"
                v-model="emailNotificationNoticeData.mailSSLVal"
                active-color="#13ce66"
                inactive-color="#ff4949"
                inactive-text="禁用"
                active-text="启用">
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="23" v-if="emailNotificationNoticeData.mailSSLVal">
            <el-form-item label="SSL端口:">
              <el-input placeholder="请输入SSL端口" size="mini" v-model="mailSSLPortData.val1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="23" >
            <el-form-item label="端口:">
              <el-input placeholder="请输入端口" size="mini" v-model="mailPortData.val1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="23" >
            <el-form-item label="发送邮箱:">
              <el-input placeholder="请输入发送邮箱" size="mini" v-model="mailSendEmailData.val1" @change="emilCheck"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="23" >
            <el-form-item label="发送用户名:">
              <el-input placeholder="请输入发送用户名" size="mini" v-model="mailSendUserNameData.val1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="23" >
            <el-form-item label="验证密码:">
              <el-switch
                style="display: block;  margin-top: 8px"
                v-model="emailNotificationNoticeData.mailVerificationVal"
                active-color="#13ce66"
                inactive-color="#ff4949"
                inactive-text="禁用"
                active-text="启用">
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :xl="20" :lg="20" :md="20" :sm="20" :xs="23" v-if="emailNotificationNoticeData.mailVerificationVal">
            <el-form-item label="密码:">
              <el-input placeholder="请输入密码" show-password size="mini" v-model="mailPasswordData.val1"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "EmailNotificationNotice",
  props:["mailSMTPData","mailPortData","mailSendEmailData","mailSendUserNameData","mailPasswordData","emailNotificationNoticeData","mailSSLPortData"],
  methods:{
    emilCheck(res){
      console.log("值：",res);
      console.log("结果：",this.data.check.emailAddressFormatCheck(res));
      if (this.data.check.emailAddressFormatCheck(res)){
        this.$message({
          message: '发送邮箱格式，请填写正确的发送邮箱',
          type: 'warning'
        });
      }
    }
  }
}
</script>

<style scoped>

.form .el-form >>> .el-form-item {
  margin-bottom: 10px;
}
</style>
